/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { AffineTransform } from './AffineTransform';
import { Vector3 } from 'three';
import { OperationDOF, Operation } from './GizmoKit';
/**
 * context of the transformation origin
 */
export class GizmoKitContext {
    constructor() {
        // Operation an constraints
        this.operation = Operation.Translate;
        this.dof = OperationDOF.NON;
        // Gizmo orientation
        this.gizmoWorldStart = new AffineTransform();
        this.gizmoStart = new AffineTransform();
        // Object orientation
        this.objectWorldStart = new AffineTransform();
        this.objectStart = new AffineTransform();
        this.surfaceMouseStart = new Vector3();
        this.referenceSize = new Vector3(1, 1, 1); // referenceSize for scaling
        this.locked = false;
    }
    init(op, dof, surfaceCenter, pointer) {
        this.operation = op;
        this.dof = dof;
        this.surfaceCenter = surfaceCenter;
        this.pointer = pointer;
    }
}
//# sourceMappingURL=GizmoKitContext.js.map